window.savePatientToCart = async function savePatientToCart(profile){
  const res = await fetch('/cart.js');
  const cart = await res.json();
  let patients = [];
  try { patients = JSON.parse(cart.attributes?.patients_json || '[]'); } catch(e) {}
  const id = profile.id || ('pt_' + Math.random().toString(36).slice(2,10));
  const next = [...patients.filter(p => p.id !== id), { ...profile, id }];
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type':'application/json' },
    body: JSON.stringify({ attributes: { patients_json: JSON.stringify(next) } })
  });
  location.reload();
};

window.assignPatient = async function assignPatient(line, qty, patientId){
  const cart = await (await fetch('/cart.js')).json();
  const item = cart.items[line - 1];
  if (!item) return;

  if (qty < item.quantity) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      body: JSON.stringify({
        id: item.id,
        quantity: qty,
        properties: Object.assign({}, item.properties, { patient_ref: patientId })
      })
    });
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      body: JSON.stringify({ line, quantity: item.quantity - qty })
    });
  } else {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      body: JSON.stringify({ line, properties: Object.assign({}, item.properties, { patient_ref: patientId }) })
    });
  }
  location.reload();
};
